



















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import PurchaseItemModel from "@/usecases/orders/purchase-item";
import PurchaseRow from "./PurchaseRow.vue";
import VTd from "./VTd.vue";
import SelectOption from "../../../common/ui/presenters/select-option";
import { ESTIMATE_ITEM_LEVEL } from "@/preferences";

@Component({
  computed: {
    ESTIMATE_ITEM_LEVEL() {
      return ESTIMATE_ITEM_LEVEL;
    }
  },
  components: {
    VTd,
    PurchaseRow
  }
})
export default class PurchaseItem extends Vue {
  @Prop({ required: true }) item!: PurchaseItemModel;
  @Prop({ default: () => [] }) unitOptions!: SelectOption[];
  @Prop({ required: true }) level!: number;
  @Prop({ required: true }) index!: number;

  change() {
    this.$emit("change");
  }

  get isDiscountRow(): boolean {
    return (
      this.item.estimateItemId === "" || Number(this.item.estimateItemId) === 0
    );
  }

  isNegative(value: number): boolean {
    return value < 0;
  }
}
